<template>
    <b-form-group
        :label="label"
        :label-for="id"
        class="ms-us-phone-input"
        :class="{
            'label-sm': labelSize === 'sm',
            'label-md': labelSize === 'md',
            'label-lg': labelSize === 'lg',
        }"
    >
        <b-input-group>
            <template #prepend>
                <b-img
                    class="phone-icon"
                    :src="require('./../../../static/flags/flag_usa.png')"
                    alt=""
                />
            </template>
            <b-form-input
                :id="id"
                :value="phoneNumber"
                class="form-control"
                :class="inputClass"
                :placeholder="placeholder"
                :name="name"
                :disabled="disabled"
                @input="onInput"
                @keydown="(e) => { lastKeyPressed = e.keyCode }"
                :autocomplete="autocomplete"
            />
            <template
                #append
                v-if="enablePhoneLabel"
            >
                <b-dropdown
                    :id="'ms-phone-input-phone-label-' + id"
                    class="ms-phone-label-dropdown w-100"
                    :text="activePhoneLabel"
                >
                    <b-dropdown-item
                        v-for="(label, index) in phoneLabels"
                        :key="'phone-label-item-' + id + '-' + index"
                        @click="changePhoneLabel(label)"
                    >
                        {{ label }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </b-input-group>
        <input-error
            :errors="errors"
            :field="name"
        />
    </b-form-group>
</template>
<script>
import './UsPhoneInput.scss';
import {generateRandomString} from "./../../../helpers/stringHelpers";
import InputError from "../../InputError/InputError.vue";
import {AsYouType, parsePhoneNumberFromString} from 'libphonenumber-js'

export default {
    name: 'UsPhoneInput',
    components: {InputError},
    props: {
        value: {
            type: [
                String,
                Number
            ],
        },
        type: {
            type: String,
            required: false,
            default: () => {
                return 'text';
            }
        },
        name: {
            type: String,
            required: false,
            default: () => {
                return 'price';
            }
        },
        label: {
            type: String,
            required: false,
            default: () => {
                return '';
            }
        },
        id: {
            type: String,
            required: false,
            default: () => {
                return generateRandomString(10);
            }
        },
        placeholder: {
            type: String,
            required: false,
            default: () => {
                return '';
            }
        },
        inputClass: {
            type: [String, Object],
            required: false,
            default: () => {
                return '';
            }
        },
        disabled: {
            type: Boolean,
            required: false,
            default: () => {
                return false;
            }
        },
        errors: {
            type: Object,
            required: false,
            default: () => ({})
        },
        labelSize: {
            type: String,
            required: false,
            default: 'sm',
            validator: (value) => {
                return [
                    'sm',
                    'md',
                    'lg'
                ].indexOf(value) > -1;
            }
        },
        enablePhoneLabel: {
            type: Boolean,
            required: false,
            default: true
        },
        phoneLabels: {
            type: Array,
            required: false,
            default: () => {
                return [
                    'mobile',
                    'work',
                    'fax'
                ];
            }
        },
        phoneLabel: {
            type: String,
            required: false,
            default: 'mobile'
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'off'
        },
    },
    data: () => ({
        lastKeyPressed: null,
        activePhoneLabel: ''
    }),
    computed: {
        phoneNumber: {
            get() {
                if (typeof this.value === "undefined" || !this.value || this.value.length < 1) {
                    return this.value;
                }
                return this.getAsYouTypeFormat(this.getPhoneInfo(this.value).nationalNumber);
            },
            set(newPhone) {
                this.$emit('input', this.getAsYouTypeFormat(newPhone));
            }
        },
    },
    methods: {
        onInput(value) {
            this.$nextTick(() => {
                let info = value;
                const phoneInfo = this.getPhoneInfo(value);
                this.$emit('input', value.length > 1 ? phoneInfo.e164 : value);
                this.$emit('update', phoneInfo);
            })
        },
        getPhoneInfo(phoneNumber) {
            if (typeof phoneNumber === "undefined") {
                phoneNumber = this.value;
            }
            const countryCode = "US";
            const parsing = phoneNumber && countryCode ? parsePhoneNumberFromString(phoneNumber, countryCode) : null
            return {
                countryCode: countryCode,
                isValid: false,
                label: this.activePhoneLabel,
                ...(phoneNumber && (phoneNumber !== '')
                        ? {phoneNumber: phoneNumber}
                        : null
                ),
                ...(parsing
                        ? {
                            countryCallingCode: parsing.countryCallingCode,
                            formattedNumber: parsing.number,
                            nationalNumber: parsing.nationalNumber,
                            isValid: parsing.isValid(),
                            type: parsing.getType(),
                            formatInternational: parsing.formatInternational(),
                            formatNational: parsing.formatNational(),
                            uri: parsing.getURI(),
                            e164: parsing.format('E.164')
                        }
                        : null
                )
            }
        },
        getAsYouTypeFormat(phone) {
            if (typeof phone === "undefined") {
                phone = this.value;
            }
            const asYouType = new AsYouType("US")
            return phone ? asYouType.input(phone) : null
        },
        changePhoneLabel(label) {
            this.activePhoneLabel = label;
            this.$emit('update', this.getPhoneInfo(this.value));
        }
    },
    beforeMount() {
        this.activePhoneLabel = this.phoneLabel;
    }
}
</script>
